<template>
  <widget-template-gallery
    api_endpoint="POST: /api/v1/guest-check-in/template-types"
    :build_api_params="buildApiParams"
    templates_response_key="template_types"
    :excluded_template_ids="['blank']"
    :selected_template_id="selected_template_id"
    :single_column="single_column"
    :watch_props="['theme']"
    @template-selected="onTemplateSelect"
    @template-deselected="$emit('template-deselected')"
    @templates-loaded="$emit('templates-loaded', $event)"
  >
    <template #template-card="{ template, is_selected, on_select, comp_custom_fonts }">
      <m-guest-check-in-template-card
        :template="template"
        :theme="theme"
        :organization_name="organization_name"
        :is_selected="is_selected"
        :background_image_url="background_image_url"
        :side_image_url="side_image_url"
        :logo_url="logo_url"
        :use_logo="use_logo"
        :user_consent_settings="user_consent_settings"
        :comp_custom_fonts="comp_custom_fonts"
        @select="on_select"
      />
    </template>
  </widget-template-gallery>
</template>

<script>
import WidgetTemplateGallery from '@/components/widget/widget-template-gallery.vue';
import mGuestCheckInTemplateCard from './m-guest-check-in-template-card.vue';

/**
 * Guest Check-In Template Gallery
 *
 * Thin wrapper around generic widget-template-gallery.
 * Provides guest-check-in-specific API configuration and template card rendering.
 */
export default {
  name: 'mGuestCheckInTemplateGallery',

  components: {
    WidgetTemplateGallery,
    mGuestCheckInTemplateCard,
  },

  props: {
    selected_template_id: {
      type: String,
      default: null,
    },

    theme: {
      type: Object,
      default: () => ({}),
    },

    organization_name: {
      type: String,
      default: 'Your Organization',
    },

    background_image_url: {
      type: String,
      default: null,
    },

    side_image_url: {
      type: String,
      default: null,
    },

    logo_url: {
      type: String,
      default: null,
    },

    use_logo: {
      type: Boolean,
      default: false,
    },

    user_consent_settings: {
      type: Object,
      default: () => ({}),
    },

    single_column: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    buildApiParams(gallery_context) {
      const params = {};

      if (this.theme?.colors?.primary?.value) {
        params.primary_color = this.theme.colors.primary.value;
      }

      if (this.theme?.colors?.secondary?.value) {
        params.secondary_color = this.theme.colors.secondary.value;
      }

      if (this.theme?.font_family) {
        params.font_family = this.theme.font_family;
      }

      if (gallery_context.$route.params.organization_id) {
        params.organization_id = gallery_context.$route.params.organization_id;
      }

      return params;
    },

    onTemplateSelect(template) {
      this.$emit('template-selected', template);
    },
  },
};
</script>

<style scoped lang="scss"></style>
